// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2-PB5","row":"Node_row__1BfpU","label":"Node_label__3NXqs","footer":"Node_footer__ik0bZ"};